// Utils
import { propIn } from '../../../common/utils/immutableHelper';

export const hybridAppNativeThemeSelector = propIn(['app', 'hybridApp', 'nativeTheme']);
